module.exports = __webpack_public_path__ + "img/settings.06fd8e71.svg";